import { gql } from "@apollo/client";

export default gql`
  query getAnnouncementCategories{
    getAnnouncementCategories{
        success
        data{
            _id
            color
            translations
            createdAt
            updatedAt
        }
        error
        message
    }
}
`
